__turbopack_context__.v({
  "direct_contact": "404-module__n0jmLq__direct_contact",
  "error_message": "404-module__n0jmLq__error_message",
});
